export default class ModuloConfiguracaoCampos {
    public habilitarCpf: boolean;

    public habilitarDocumentoMedico: boolean;

    constructor() {
      this.habilitarCpf = false;
      this.habilitarDocumentoMedico = false;
    }
}
